import { render, staticRenderFns } from "./serviceRateCell.vue?vue&type=template&id=b5f41542&scoped=true"
import script from "./serviceRateCell.vue?vue&type=script&lang=js"
export * from "./serviceRateCell.vue?vue&type=script&lang=js"
import style0 from "./serviceRateCell.vue?vue&type=style&index=0&id=b5f41542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f41542",
  null
  
)

export default component.exports